import SignIn from './SignIn'

export default SignIn



// WEBPACK FOOTER //
// ./src/views/SignIn/index.js